
// Enums
export enum Module {
    Core = 'core',
    Setting = 'setting',
    Sales = 'sales',
    Report = 'report',
    Entity = 'entity',
    Receiving = 'receiving',
    TechRepair = 'tech-repair',
    Inspection = 'tech-inspection',
    Zeus = 'zeus',
    Billing = 'billing',
    Inventory = 'inventory'
}

export enum NoteType {
    Receiving = 1,
    Repair = 2
}

export enum ItemType {
    Product = 1,
    Part = 2
}

export enum NoteCategoryIds {
    General = 2
}

export enum Gender {
    Masculine = 'masculine',
    Feminine = 'feminine',
    Neuter = 'neuter'
}

export enum ReportConfigTemplateCodes {
    Sales = 'sales',
    RecevingRepairInspection = 'receving-repair-inspection'
}


export enum SalesOrderStatusCodes {
    Received = <any>'617861f3b05fcb09047161e3',
    Started = <any>'618078e8c7c0c35add492c6d', 
    Cancelled = <any>'61807917c7c0c35add492c6f',
    Finished = <any>'619a5bbb6eb5452fb561cc2e',
}

export enum ReceivingStatusCodes {
    New = <any>'62b08d51607934cba0695cc1',
    Receiving = <any>'62b08ff5607934cba0695cc5',
    OnHold = <any>'62b08ffd607934cba0695cc6',
    Finished = <any>'62b09001607934cba0695cc7',
    Canceled = <any>'62b09b8b607934cba0695cce'
}

export enum RepairStatusCodes {
    TechOut = <any>'67895869e99772f4597c4870',
    Repairing = <any>'67895924e99772f4597c4872',
    OnHold = <any>'67895a1ae99772f4597c4874',
    Finished = <any>'67895a29e99772f4597c4876',
    Canceled = <any>'67895a7ee99772f4597c487a',
    ReturnToTech = <any>'6828dfc6d6c703837f468275'
  }

export enum InspectionStatusCodes {
    Inspecting = <any>'682514b7ccc995e34bf7f060',
    OnHold = <any>'682514b7ccc995e34bf7f061',
    Finished = <any>'682514b7ccc995e34bf7f062'
}  

export enum ReceivingStatusReasonCodes {
  Other = '6303f0189ca56122054fe32c'
}

export enum RepairStatusReasonCodes {
    Other = '678e544db347f43e0ea364d0'
}

export enum InspectionStatusReasonCodes {
    Other = '6825142dccc995e34bf7f05c'
}

export enum InvoiceStatusCodes {
    Pending = '6271970d7a0d38821e5014a8',
    Complete = '6271970d7a0d38821e5014a9',
    Canceled = '6271970d7a0d38821e5014aa'
}

export enum InventoryEventCodes {
    StockTransfer = '671fd3dcddd80e26962dd3ef',
    StockAdjustment = '671fd3dcddd80e26962dd3f0'
}

export enum TransactionStatusCodes {
    Received = '67094df5d218b186a3d72941',
    Repaired = '67b795a8ee634cbea0a64368'
}

export enum NoteCategory {
    General  = 2
}

export enum QueryOdataFilter {
    AfterNew =  '{ "fields": [ {"field": "_id", "value": "#", "isExactValue": true} ] }',
}

export enum InspectionResultCode { 
    Repaired = 1,
    Scrap = 2,
    ScratchAndDent = 3,
    ReturnToTech = 4
}

export enum PricingConfigurationTriggerCodes {
  Received = '62674856bd7aa51b3bdabe6a',
  Repaired = '62674856bd7aa51b3bdabe6b',
  Inspected = '62674856bd7aa51b3bdabe6c',
  ScrapReceiving = '62674856bd7aa51b3bdabe6d',
  ScrapRepairInspection = '62674856bd7aa51b3bdabe6e',
  ReceivedAndNotRepaired = '6865a6e80d8cad6ded7ae6c7',
  Manually = '68653a3c0d8cad6ded7ae6b4',
  FixedPrice = '6876f2f8b72c30f243b372c4'
}

export enum LocationCodes {
  NewlyRepaired_HUB900 = '67c9c281dbdd44ab85a8b2a6',
  NewlyInspected_HUB901 = '67c9c2bfdbdd44ab85a8b2a7',
  Parts_HUB902 = '684de0bc496726f164594398'
}

export enum CountryCodes {
  Canada = '623284b0179b83b914353fad'
}



// Classes


// Interfaces




  //Const 
export const InputMask = {
    Email: {alias: 'email'}
}

export const StyleLabels = {
    Receiving: `
    <style>
        .label {
            padding-top: 4px; 
            padding-left: 16px;
        }
        .barcode {
            width: 1.8333in; 
            height: 44px;
        }
        .text-below-c1 {
            width: 120px;
            text-align: left; 
        }
        .text-below-c2 {
            width: 40px;
            text-align: center; 
        }
        .text-below-c3 {
            width: 40px;
            text-align: right; 
        }
        .text-below {
            font-size: 11px; 
            display: inline-block; 
            margin: 5px; 
            overflow: hidden; 
            white-space: nowrap;
        }

        @media print {
            @page {
                margin: 0.01in; 
            }

            body {
                margin: 0;
            }
        }
    </style>
    `,
 

}





